<template>
  <CompletionChart
    label="What is our submission rate for gender data?"
    :data="data"
    widget-download-id="gender-survey-completion"
    tooltip-key="demo-survey-submission"
  />
</template>

<script setup>
import CompletionChart from '@/components/insights/ProcessInsights/DemographicSurveyReport/charts/CompletionChart.vue';
import { useDemographicSurveyReport } from '@/stores/insights/demographicSurveyReport';
import { storeToRefs } from 'pinia';

const { genderBreakdown } = storeToRefs(useDemographicSurveyReport());

const {
  male = 0,
  female = 0,
  declined,
  unknown,
} = genderBreakdown.value;

const data = [
  male + female,
  declined || 0,
  unknown || 0,
];
</script>
